import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {TypeSliderComponent} from './type-slider.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    TypeSliderComponent,
  ],
  exports: [
    TypeSliderComponent,
  ],
})
export class TypeSliderModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-slider/type-slider.module.ts